
const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://api.yearbookhub.online";

// Prepare images locally without uploading first.
export function preparePhotos(files) {
  if (!files || !files.length) {
    return { photos: [] };
  }

  const photos = Array.from(files).map((file) => {
    if (!file.type.startsWith("image/")) {
      throw new Error(`${file.name} is not an image file.`);
    }

    return {
      id: crypto.randomUUID(),
      name: file.name,
      file,
      src: URL.createObjectURL(file),
      width: 0,
      height: 0,
      portrait: false,
    };
  });

  return { photos };
}

// Upload one image to Cloudinary through your existing backend.
export async function uploadPhoto(photo) {
  const formData = new FormData();
  formData.append("image", photo.file);

  const response = await fetch(`${API_URL}/api/upload`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data.imageUrl) {
    throw new Error(
      data.message || `Failed to upload ${photo.name}`
    );
  }

  return data.imageUrl;
}
